/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Retrieving_Latest_CommitInputs */



/**
* | output |
* | --- |
* | "Retrieving latest commit from server..." |
*
* @param {Team_Sync_Status_Retrieving_Latest_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_retrieving_latest_commit = /** @type {((inputs?: Team_Sync_Status_Retrieving_Latest_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Retrieving_Latest_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Récupération du dernier commit depuis le serveur...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rufe den neuesten Commit vom Server ab...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Recupero dell'ultimo commit dal server...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получение последнего коммита с сервера...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recuperando la última confirmación del servidor...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在从服务器获取最新提交...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サーバーから最新のコミットを取得しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सर्वर से नवीनतम कमिट प्राप्त किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recuperando o último commit do servidor...")
	return /** @type {LocalizedString} */ ("Retrieving latest commit from server...")
});